import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../Style.css";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useCombinedContext } from "../../context/CombinedContext";
import axiosInstance from "../../services/auth";
import "./User.css";

const AddUser = () => {
  const url = process.env.REACT_APP_BACKEND_URL;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState([]); // State to store selected companies
  const [role, setRole] = useState("user");

  const [loading, setLoading] = useState(false);
  const [selectedRoutes, setSelectedRoutes] = useState([]);

  const navigate = useNavigate();
  const { allCompanies, setAllCompanies } = useCombinedContext(); // Store all available companies
  const routes = [
    // { value: 'profile', label: 'Profile' },
    { value: "location", label: "Job Location" },
    { value: "vessel", label: "Vessel" },
    { value: "invoice", label: "Invoice" },
    { value: "report", label: "Report" },
    { value: "employee", label: "Employee" },
    { value: "loan", label: "Loan" },
    { value: "logistics", label: "Logistics" },
    { value: "foodallowance", label: "Food Allowance" },
  ];

  // Get all companies when the component mounts
  useEffect(() => {
    const getAllCompanies = async () => {
      try {
        const response = await axiosInstance.get(`/company`);
        setAllCompanies(response.data.data || []); // Set fetched companies
      } catch (error) {
        // console.error("Error fetching companies:", error);
        toast.error("Failed to load companies.");
      }
    };
    getAllCompanies();
  }, []);

  const companies = allCompanies || [];

  const { company } = useCombinedContext();
  // console.log("comapny from useContext",company)
  // const companies = company?.company || [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      await axiosInstance.post(`/auth/signin`, {
        name,
        email,
        password,
        company: selectedCompanies,
        route: [...new Set([...selectedRoutes, "profile"])], // Send the selected companies
        role,
      });
      setName("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setSelectedCompanies([]); // Reset selected companies
      setSelectedRoutes([]); // Reset selected routes as well
      toast.success("User added successfully!");
    } catch (error) {
      // console.log(error); // Log the error to inspect the structure

      // Check if the error has a response object with a code
      if (
        error.response &&
        error.response.data &&
        error.response.data.error.code === 11000
      ) {
        toast.error(`The email ${email} is already taken.`);
      } else {
        toast.error(
          error.response?.data?.message || error.message || "An error occurred",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // Handle checkbox selection
  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    if (checked) {
      setSelectedCompanies([...selectedCompanies, value]); // Add company to the selection
    } else {
      setSelectedCompanies(
        selectedCompanies.filter((company) => company !== value),
      ); // Remove company from the selection
    }
  };

  const isCompanyChecked = (companyId) => {
    return selectedCompanies.includes(companyId);
  };
  const handleRouteCheckboxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    if (checked) {
      setSelectedRoutes([...selectedRoutes, value]);
    } else {
      setSelectedRoutes(selectedRoutes.filter((route) => route !== value));
    }
  };

  return (
    <div>
      {/* ToastContainer to display toast notifications */}
      <ToastContainer />

      <form onSubmit={handleSubmit} className="profile_form mt-3 mb-3">
        <div className="">
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label className="form-label">Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label">Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <div className="mb-3 col-md-6">
              <label className="form-label ">Role</label>
              <select
                className="form-select custom-select-sm"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label h6">Select Pages</label>
          <div className="row">
            {routes.map(({ value, label }) => (
              <div key={value} className="col-md-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={value}
                    id={`route-${value}`}
                    onChange={handleRouteCheckboxChange}
                    checked={selectedRoutes.includes(value)} // This line binds the checked state
                    style={{ cursor: "pointer" }}

                    // checked={value === "profile" || selectedRoutes.includes(value)}
                    // disabled={value === "profile"}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`route-${value}`}
                    style={{ cursor: "pointer" }}
                  >
                    {label}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Checkboxes for selecting companies */}
        <div className="mb-3">
          <label className="form-label h6">Select Companies</label>
          <div className="row">
            {companies.map((comp) => (
              <div key={comp._id} className="col-md-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    value={comp._id}
                    className="form-check-input"
                    id={`company-${comp._id}`}
                    checked={isCompanyChecked(comp._id)} // Dynamically set the checkbox state
                    onChange={handleCheckboxChange}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`company-${comp._id}`}
                    style={{ cursor: "pointer" }}
                  >
                    {comp.company_name}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button type="submit" className="button-2" disabled={loading}>
          {loading ? "Adding..." : "Add User"}
        </button>
      </form>
    </div>
  );
};

export default AddUser;
